function normalizarDocumento(valor) {
  const numeros = String(valor || "").replace(/\D/g, "");
  return numeros.length === 11 || numeros.length === 14 ? numeros : null;
}

function obterPayloadTokenArta() {
  try {
    const token = String(sessionStorage.getItem("token") || "")
      .replace(/^Bearer\s+/i, "")
      .trim();
    const partePayload = token.split(".")[1];

    if (!partePayload) return {};

    const base64 = partePayload
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .padEnd(Math.ceil(partePayload.length / 4) * 4, "=");

    return JSON.parse(window.atob(base64));
  } catch (error) {
    console.warn("Não foi possível ler o CPF/CNPJ do token do ARTA.", error);
    return {};
  }
}

export function obterDocumentoAssociado(dadosUsuario) {
  const cadastro = dadosUsuario?.dadosCadastraisAssociado;
  const dados = Array.isArray(cadastro) ? cadastro[0] || {} : cadastro || {};
  const payloadToken = obterPayloadTokenArta();
  const candidatos = [
    ["cadastro.DOC", dados.DOC],
    ["cadastro.doc", dados.doc],
    ["cadastro.CNPJ", dados.CNPJ],
    ["cadastro.cnpj", dados.cnpj],
    ["cadastro.CGCCFO", dados.CGCCFO],
    ["cadastro.cgccfo", dados.cgccfo],
    ["sessao.DOC", dadosUsuario?.DOC],
    ["sessao.doc", dadosUsuario?.doc],
    ["sessao.CNPJ", dadosUsuario?.CNPJ],
    ["sessao.cnpj", dadosUsuario?.cnpj],
    ["sessao.CPFCNPJ", dadosUsuario?.CPFCNPJ],
    ["sessao.cpfcnpj", dadosUsuario?.cpfcnpj],
    ["sessao.cpfCnpj", dadosUsuario?.cpfCnpj],
    ["jwt.CPFCNPJ", payloadToken.CPFCNPJ],
    ["jwt.cpfcnpj", payloadToken.cpfcnpj],
    ["jwt.cpfCnpj", payloadToken.cpfCnpj],
  ];

  if (process.env.NODE_ENV !== "production") {
    console.group("[Assistência Funeral Zelo] Diagnóstico do CPF/CNPJ");
    console.log("Dados completos da sessão:", dadosUsuario);
    console.log("dadosCadastraisAssociado recebido:", cadastro);
    console.log("Primeiro cadastro considerado:", dados);
    console.log("Chaves do cadastro:", Object.keys(dados));
    console.log("Claims decodificadas do JWT:", payloadToken);
    console.table(
      candidatos.map(([origem, valor]) => ({
        origem,
        valor,
        documentoNormalizado: normalizarDocumento(valor),
      }))
    );
    console.groupEnd();
  }

  for (const [, candidato] of candidatos) {
    const documento = normalizarDocumento(candidato);
    if (documento) return documento;
  }

  return null;
}
